export default __webpack_public_path__ + "static/media/imagez2.0f1fda85.PNG";